import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  IconButton,
  Typography
} from '@mui/material';
import { Edit, Delete } from '@mui/icons-material';
import { flowBgKindLabel } from './flow/components/flowBgAssetsUi';

const thumbSx = {
  width: 72,
  height: 48,
  objectFit: 'cover',
  borderRadius: 1,
  display: 'block',
  backgroundColor: 'action.hover'
};

/**
 * @param {'background' | 'location'} [props.mode]
 */
const BackgroundList = ({ items, onEdit, onDelete, mode = 'background' }) => {
  const list = items || [];
  const isLocation = mode === 'location';

  const emptyText = isLocation
    ? 'No locations yet. Add PNG/JPEG — stored in R2.'
    : 'No background images. Upload PNG/JPEG — stored in R2.';

  const labelCell = (row) => {
    if (isLocation) {
      const t = String(row.label || '').trim();
      return t || '—';
    }
    return flowBgKindLabel(row.kind === 'slide' ? 'slide' : 'background');
  };

  return (
    <TableContainer component={Paper} variant="outlined" sx={{ overflowX: 'auto' }}>
      <Table size="small" stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell>Preview</TableCell>
            <TableCell>Label</TableCell>
            <TableCell>Id</TableCell>
            <TableCell>Created</TableCell>
            <TableCell align="right" sx={{ whiteSpace: 'nowrap', minWidth: 112 }}>
              Actions
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {list.length === 0 ? (
            <TableRow>
              <TableCell colSpan={5} align="center">
                <Typography variant="body2" color="text.secondary">
                  {emptyText}
                </Typography>
              </TableCell>
            </TableRow>
          ) : (
            list.map((row) => (
              <TableRow key={row._id} hover>
                <TableCell sx={{ width: 96 }}>
                  <Box component="img" src={row.thumbnailUrl || row.imageUrl} alt="" sx={thumbSx} />
                </TableCell>
                <TableCell>
                  <Typography variant="body2">{labelCell(row)}</Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="caption" fontFamily="monospace" color="text.secondary">
                    {row._id}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body2" color="textSecondary">
                    {row.createdAt ? new Date(row.createdAt).toLocaleDateString() : '—'}
                  </Typography>
                </TableCell>
                <TableCell align="right" sx={{ whiteSpace: 'nowrap', minWidth: 112 }}>
                  <Box sx={{ display: 'inline-flex', gap: 0.25, justifyContent: 'flex-end' }}>
                    <IconButton size="small" onClick={() => onEdit(row)} color="primary">
                      <Edit />
                    </IconButton>
                    <IconButton size="small" onClick={() => onDelete(row._id)} color="error">
                      <Delete />
                    </IconButton>
                  </Box>
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default BackgroundList;
